import {
  CACHE_TAG_ROUTES_METADATA_BY_DATE,
  CACHE_TAG_ROUTES_UNASSIGNED_WORK_ORDERS,
  CACHE_TAG_ROUTES_STOPS,
  CACHE_TAG_ROUTES_GEOJSON,
} from 'api/cacheTagTypes'

export const POLLING_INTERVALS = {
  FIVE: { label: '5 min', value: `${5 * 60 * 1000}` },
  TEN: { label: '10 min', value: `${10 * 60 * 1000}` },
}

export const getCacheTags = (isUnassignedStopsOpen, isMapview) => {
  const cacheTags = [CACHE_TAG_ROUTES_METADATA_BY_DATE, CACHE_TAG_ROUTES_STOPS]
  if (isUnassignedStopsOpen) {
    cacheTags.push(CACHE_TAG_ROUTES_UNASSIGNED_WORK_ORDERS)
  }

  if (isMapview) {
    cacheTags.push(CACHE_TAG_ROUTES_GEOJSON)
  }

  return cacheTags
}
